import styles from 'components/commission-management/budget/BudgetTable.module.css';

export default styles;